var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.jobObj.status === 5)?_c('span',[_vm._v("The request has been completed successfully.")]):_vm._e(),(_vm.jobObj.downloadLink)?_c('span',[_vm._v("The output file can be downloaded "),_c('a',{attrs:{"href":_vm.jobObj.downloadLink,"target":"_blank"}},[_vm._v("here")]),_vm._v(".")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }